import { render, staticRenderFns } from "./EditBehaviour.vue?vue&type=template&id=0ef4f667&"
import script from "./EditBehaviour.vue?vue&type=script&lang=js&"
export * from "./EditBehaviour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports